import {
  useTargetScoreRanges,
  useHeadOfHouseholdMaxTargetScoreAgeGroup,
  targetScoreRangeFromElementAndAgeGroup,
} from '../../TargetScore';

export const useTargetScoreRangesForElements = ({ firmID, clientID }: { firmID: string; clientID: string }) => {
  const { targetScoreRangesData } = useTargetScoreRanges({ clientID });
  const { ageGroup } = useHeadOfHouseholdMaxTargetScoreAgeGroup({
    firmID,
    firmClientID: clientID,
  });
  const irRange = targetScoreRangeFromElementAndAgeGroup({
    element: 'Ir',
    ageGroup,
    targetScoreRanges: targetScoreRangesData?.ranges,
  });
  const erRange = targetScoreRangeFromElementAndAgeGroup({
    element: 'Er',
    ageGroup,
    targetScoreRanges: targetScoreRangesData?.ranges,
  });
  const esRange = targetScoreRangeFromElementAndAgeGroup({
    element: 'Es',
    ageGroup,
    targetScoreRanges: targetScoreRangesData?.ranges,
  });
  const srRange = targetScoreRangeFromElementAndAgeGroup({
    element: 'Sr',
    ageGroup,
    targetScoreRanges: targetScoreRangesData?.ranges,
  });
  const brRange = targetScoreRangeFromElementAndAgeGroup({
    element: 'Br',
    ageGroup,
    targetScoreRanges: targetScoreRangesData?.ranges,
  });
  const drRange = targetScoreRangeFromElementAndAgeGroup({
    element: 'Dr',
    ageGroup,
    targetScoreRanges: targetScoreRangesData?.ranges,
  });
  const trRange = targetScoreRangeFromElementAndAgeGroup({
    element: 'Tr',
    ageGroup,
    targetScoreRanges: targetScoreRangesData?.ranges,
  });
  const ltRange = targetScoreRangeFromElementAndAgeGroup({
    element: 'Lt',
    ageGroup,
    targetScoreRanges: targetScoreRangesData?.ranges,
  });
  const qtRange = targetScoreRangeFromElementAndAgeGroup({
    element: 'Qt',
    ageGroup,
    targetScoreRanges: targetScoreRangesData?.ranges,
  });
  const rtRange = targetScoreRangeFromElementAndAgeGroup({
    element: 'Rt',
    ageGroup,
    targetScoreRanges: targetScoreRangesData?.ranges,
  });
  const btRange = targetScoreRangeFromElementAndAgeGroup({
    element: 'Bt',
    ageGroup,
    targetScoreRanges: targetScoreRangesData?.ranges,
  });
  const ttRange = targetScoreRangeFromElementAndAgeGroup({
    element: 'Tt',
    ageGroup,
    targetScoreRanges: targetScoreRangesData?.ranges,
  });

  return {
    ir: { min: irRange?.range?.min, max: irRange?.range?.max },
    er: { min: erRange?.range?.min, max: erRange?.range?.max },
    es: { min: esRange?.range?.min, max: esRange?.range?.max },
    sr: { min: srRange?.range?.min, max: srRange?.range?.max },
    br: { min: brRange?.range?.min, max: brRange?.range?.max },
    dr: { min: drRange?.range?.min, max: drRange?.range?.max },
    tr: { min: trRange?.range?.min, max: trRange?.range?.max },
    lt: { min: ltRange?.range?.min, max: ltRange?.range?.max },
    qt: { min: qtRange?.range?.min, max: qtRange?.range?.max },
    rt: { min: rtRange?.range?.min, max: rtRange?.range?.max },
    bt: { min: btRange?.range?.min, max: btRange?.range?.max },
    tt: { min: ttRange?.range?.min, max: ttRange?.range?.max },
  };
};
